module.exports = __webpack_public_path__ + "static/media/noActionsItems.b3e0ba31.svg";